const reviews = [
  {
    name: "Kevin M.",
    location: "Billings Heights, MT",
    rating: 5,
    text: "We needed passports for our whole family before a cruise and Fast Passport Center came through. Denver was not an option — too far, too expensive. Got everything back in 6 days. Incredible service.",
    service: "Family Renewal",
  },
  {
    name: "Sandra L.",
    location: "Downtown Billings, MT",
    rating: 5,
    text: "My agent called me every single day with updates. As someone who has had to scramble for passport renewals before, this level of communication was amazing. Will never do it the post office way again.",
    service: "Expedited Renewal",
  },
  {
    name: "Tom W.",
    location: "Laurel, MT",
    rating: 5,
    text: "Lost my passport three days before a business trip to Canada. Fast Passport Center had me sorted in 48 hours. I couldn't believe it. The team in Billings was so relieved — and so was I.",
    service: "Emergency Replacement",
  },
];

export default function TestimonialsSection() {
  return (
    <section id="reviews" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Billings Travelers Are Saying
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Real customers. Real results. No Denver agency trip required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-7 flex flex-col">
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-1">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{r.name}</p>
                  <p className="text-gray-400 text-xs">{r.location}</p>
                </div>
                <span className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                  {r.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}